import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-firma-upload',
  templateUrl: './firma-upload.component.html',
  styleUrls: ['./firma-upload.component.scss']
})
export class FirmaUploadComponent implements OnChanges {
  @ViewChild('fileInput', { static: true }) fileInput!: ElementRef<HTMLInputElement>;

  @Input() allowedTypes: string[] = [];
  @Input() existingImageUrl: string | null = null;
  @Output() fileSelected = new EventEmitter<File>();

  previewUrl: string | null = null;
  isDragOver = false;

  ngOnChanges(changes: SimpleChanges): void {
    // 👇 Si se recibe una imagen existente, se muestra como vista previa
    if (changes['existingImageUrl'] && this.existingImageUrl) {
      this.previewUrl = this.existingImageUrl;
    }
  }

  // --- Clic para abrir selector ---
  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  // --- Manejo de archivo desde input ---
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.processFile(input.files[0]);
    }
  }

  // --- Drag & Drop ---
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.processFile(files[0]);
    }
  }

  // --- Procesar archivo (validar + previsualizar + emitir) ---
  private processFile(file: File): void {
    // Validación de tipo
    if (this.allowedTypes.length > 0) {
      const isValid = this.allowedTypes.some(type => {
        if (type.endsWith('/*')) {
          const base = type.replace('/*', '');
          return file.type.startsWith(base + '/');
        }
        return file.type === type;
      });

      if (!isValid) {
        alert(`Tipo no permitido. Se permiten: ${this.allowedTypes.join(', ')}`);
        return;
      }
    }

    this.previewUrl = URL.createObjectURL(file);

    this.fileSelected.emit(file);

    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }
}
